// typed wrapper module around the env global js variable

declare let window: OldUIContext.TenForceWindow
const env: OldUIContext.Env = window.env

export default env
